var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.417,
    height: 13.112,
    viewBox: "0 0 12.417 13.112",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3045",
    "data-name": "Group 3045",
    transform: "translate(-624.27 -292.023)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_1110",
    "data-name": "Ellipse 1110",
    d: "M3-.9A3.9,3.9,0,1,1-.9,3,3.906,3.906,0,0,1,3-.9Zm0,6A2.1,2.1,0,1,0,.9,3,2.1,2.1,0,0,0,3,5.1Z",
    transform: "translate(627.477 292.923)",
    fill: "#4b9ce2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3887",
    "data-name": "Path 3887",
    d: "M635.787,316.313a.9.9,0,0,1-.9-.9,4.409,4.409,0,1,0-8.817,0,.9.9,0,0,1-1.8,0,6.209,6.209,0,0,1,12.417,0A.9.9,0,0,1,635.787,316.313Z",
    transform: "translate(0 -11.178)",
    fill: "#4b9ce2"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.0e8ebff59ac958b4c04360484a4afc24.svg";
export { ForwardRef as ReactComponent };